const cleanValue = (value) => {
  if (value === null || value === undefined) return undefined;
  if (typeof value !== 'string') return value;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

const pickField = (...candidates) => {
  for (const candidate of candidates) {
    const cleaned = cleanValue(candidate);
    if (cleaned !== undefined) {
      return cleaned;
    }
  }
  return undefined;
};

export const normalizeContactDetails = (contact) => {
  if (!contact || typeof contact !== 'object') return null;

  const addressLine1 = pickField(
    contact.address,
    contact.addressLine1,
    contact.address_line1,
    contact.address1,
    contact.street,
    contact.street1,
    contact.line1,
    contact.billingAddress,
    contact.billing_address
  );

  const addressLine2 = pickField(
    contact.addressLine2,
    contact.address_line2,
    contact.address2,
    contact.street2,
    contact.street_2,
    contact.line2
  );

  const city = pickField(
    contact.city,
    contact.town,
    contact.locality,
    contact.cityName,
    contact.billingCity,
    contact.city_name
  );

  const state = pickField(
    contact.state,
    contact.county,
    contact.region,
    contact.province,
    contact.stateProvince,
    contact.billingState,
    contact.state_name
  );

  const zipCode = pickField(
    contact.zipCode,
    contact.zip_code,
    contact.postalCode,
    contact.postal_code,
    contact.postcode,
    contact.post_code,
    contact.zip,
    contact.pinCode,
    contact.billingZip
  );

  const country = pickField(
    contact.country,
    contact.countryName,
    contact.country_code,
    contact.countryCode,
    contact.countryname
  );

  const companyName = pickField(
    contact.companyName,
    contact.company,
    contact.businessName,
    contact.organisation,
    contact.organization,
    contact.accountName,
    contact.name
  );

  const firstName = pickField(
    contact.firstName,
    contact.firstname,
    contact.givenName,
    contact.name && contact.name.split(' ')[0]
  );

  const lastName = pickField(
    contact.lastName,
    contact.lastname,
    contact.familyName,
    contact.surname,
    contact.name && contact.name.split(' ').slice(1).join(' ').trim()
  );

  const email = pickField(
    contact.email,
    contact.contactEmail,
    contact.emailAddress,
    contact.email_address,
    contact.recipientEmail
  );

  return {
    ...contact,
    companyName: companyName || contact.companyName || contact.company || undefined,
    firstName: firstName || contact.firstName || undefined,
    lastName: lastName || contact.lastName || undefined,
    email: email || contact.email || undefined,
    address:
      typeof contact.address === 'string' && contact.address.trim().length > 0
        ? contact.address
        : pickField(addressLine1, [addressLine1, addressLine2].filter(Boolean).join(', ')),
    city: city || contact.city || undefined,
    state: state || contact.state || undefined,
    zipCode: zipCode || contact.zipCode || undefined,
    country: country || contact.country || undefined
  };
};

export const buildContactFromSources = (...sources) => {
  const candidate = sources.find((source) => source && Object.keys(source).length > 0);
  return normalizeContactDetails(candidate);
};

export const extractBusinessProfile = (user = {}) => {
  if (!user) {
    return {
      companyName: '',
      address: '',
      city: '',
      state: '',
      zipCode: '',
      country: 'United Kingdom'
    };
  }

  const rawAddress =
    typeof user.address === 'string'
      ? { address: user.address }
      : user.address || {};

  const normalized = normalizeContactDetails({
    ...rawAddress,
    address: rawAddress.address || user.addressLine1 || user.street || user.billingAddress || '',
    city: rawAddress.city || user.city || user.billingCity,
    state: rawAddress.state || user.state || user.billingState,
    zipCode: rawAddress.zipCode || user.zipCode || user.billingZip,
    country: rawAddress.country || user.country || user.billingCountry
  }) || {};

  return {
    companyName:
      cleanValue(user.companyName) ||
      cleanValue(user.company_name) ||
      cleanValue(user.company?.name) ||
      '',
    address: normalized.address || '',
    city: normalized.city || '',
    state: normalized.state || '',
    zipCode: normalized.zipCode || '',
    country: normalized.country || 'United Kingdom'
  };
};

